import { showInstance } from './snackbar-container';
import { ActionData, SnackbarType } from './types';

const getShowSnackbar = (type: SnackbarType) => (message: string) => {
  if (showInstance) {
    showInstance(type, message);
  }
};

const getShowSnackbarWithAction =
  (type: SnackbarType) => (message: string, actionData?: ActionData) => {
    if (showInstance) {
      showInstance(type, message, actionData);
    }
  };

export const snackbar = {
  regular: getShowSnackbarWithAction(SnackbarType.Regular),
  info: getShowSnackbar(SnackbarType.Info),
  warning: getShowSnackbar(SnackbarType.Warning),
  error: getShowSnackbar(SnackbarType.Error),
  success: getShowSnackbar(SnackbarType.Success),
};
